import React from 'react';

import { useFormContext } from 'react-hook-form';
import { observer } from 'mobx-react';

import { MultipleComboBox } from '../../../../../../../../components/form-components';
import { CustomFilterFormValues } from '../../../AddCustomFilterForm.settings';
import { useSchoolsList } from '../../../../../../../../hooks/schools/useSchoolsList';

const SchoolGroupFilter = observer(() => {
  const { control } = useFormContext<CustomFilterFormValues>();

  const { schoolListOption } = useSchoolsList({
    isRunGlobalSpinner: false,
    isScholastic: false,
  });

  return (
    <MultipleComboBox
      control={control}
      size="small"
      variant="outlined"
      name="filters.PERSONAL_INFO.schoolIds"
      label="School/Team/Organization"
      options={schoolListOption}
      limitTags={3}
    />
  );
});

export { SchoolGroupFilter };
